import { render, staticRenderFns } from "./regionalDirectorEdit.vue?vue&type=template&id=1aedd1fc&scoped=true&"
import script from "./regionalDirectorEdit.vue?vue&type=script&lang=js&"
export * from "./regionalDirectorEdit.vue?vue&type=script&lang=js&"
import style0 from "./regionalDirectorEdit.vue?vue&type=style&index=0&id=1aedd1fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aedd1fc",
  null
  
)

export default component.exports